import React, { useState, useEffect, useMemo } from 'react'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/formularios.css';
import '../styles/styles.css';
import logoInstituto from '../components/images/logo.png';
import logoSEP from '../components/images/SEP_Logo_2019.svg.png';
import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';


const RegistrarHorarios = () => {
  const [grupo, setGrupo] = useState('');
  const [materia, setMateria] = useState('');
  const [diaSemana, setDiaSemana] = useState('');
  const [horaInicio, setHoraInicio] = useState('');
  const [horaFinal, setHoraFinal] = useState('');
  const [aula, setAula] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const handleSalir = () => {
    const rol = resolveRolBase(location.pathname);
    if (rol) {
      navigate(`/${rol}/inicio`, { replace: true });
    } else {
      // Fallback por si no se detecta rol ni en path ni en localStorage:
      navigate('/inicio', { replace: true });
    }
  };

  // === NUEVO: bloques y días oficiales (sin tocar tus controles) ===
  const bloques = useMemo(
    () => [
      '07:30 - 08:20',
      '08:20 - 09:10',
      '09:10 - 10:00',
      '10:00 - 10:30', // Receso
      '10:30 - 11:20',
      '11:20 - 12:10',
      '12:10 - 12:45', // Receso
      '12:45 - 13:35',
      '13:35 - 14:25',
    ],
    []
  );

  const dias = useMemo(
    () => ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'],
    []
  );

  // === NUEVO: helper para detectar traslapes (HH:MM comparables) ===
  const traslapan = (iniA, finA, iniB, finB) => {
    if (!iniA || !finA) return false;
    // Formatos "HH:MM" → comparables lexicográficamente
    return iniA <= finB && finA >= iniB;
  };

  // Si quisieras normalizar a "HH:MM" por si llegan vacíos, puedes usar esto
  const horaInicioNorm = horaInicio; // inputs type="time" ya devuelven HH:MM
  const horaFinalNorm  = horaFinal;

  useEffect(() => {
    // Si se desea hacer alguna inicialización
  }, []);

  return (
    <div className="container py-4 px-4">
      {/* Encabezado */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Registrar Horarios</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>

      {/* Formulario */}
      <div className="p-4 bg-light rounded shadow-sm">
        <form className="row g-3" id="formularioHorarios">
          <div className="col-md-4">
            <label htmlFor="idHorario" className="form-label">ID Horario</label>
            <input type="text" className="form-control" id="idHorario" placeholder="Auto" disabled />
          </div>

          <div className="col-md-4">
            <label htmlFor="grupo" className="form-label">Grupo</label>
            <select
              id="grupo"
              className="form-select"
              value={grupo}
              onChange={(e) => setGrupo(e.target.value)}
            >
              <option value="" disabled>Selecciona Grupo</option>
              <option value="Primero">Primero</option>
              <option value="Segundo">Segundo</option>
              <option value="Tercero">Tercero</option>
              <option value="Cuarto">Cuarto</option>
              <option value="Quinto">Quinto</option>
              <option value="Sexto">Sexto</option>
            </select>
          </div>

          <div className="col-md-4">
            <label htmlFor="materiaImpartir" className="form-label">Materia a Impartir</label>
            <select
              id="materiaImpartir"
              className="form-select"
              value={materia}
              onChange={(e) => setMateria(e.target.value)}
            >
              <option value="" disabled>Selecciona Materia</option>
              <option value="Matematicas">Matemáticas</option>
              <option value="Español">Español</option>
              <option value="Ciencias">Ciencias</option>
              <option value="Historia">Historia</option>
              <option value="Geografia">Geografía</option>
              <option value="Ingles">Inglés</option>
            </select>
          </div>

          <div className="col-md-4">
            <label htmlFor="diaSemana" className="form-label">Día de la Semana</label>
            <select
              id="diaSemana"
              className="form-select"
              value={diaSemana}
              onChange={(e) => setDiaSemana(e.target.value)}
            >
              <option value="" disabled>Selecciona Día</option>
              <option value="Lunes">Lunes</option>
              <option value="Martes">Martes</option>
              <option value="Miércoles">Miércoles</option>
              <option value="Jueves">Jueves</option>
              <option value="Viernes">Viernes</option>
            </select>
          </div>

          <div className="col-md-3">
            <label htmlFor="horaInicio" className="form-label">Hora de Inicio</label>
            <input
              type="time"
              className="form-control"
              id="horaInicio"
              value={horaInicio}
              onChange={(e) => setHoraInicio(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <label htmlFor="horaFinal" className="form-label">Hora de Finalización</label>
            <input
              type="time"
              className="form-control"
              id="horaFinal"
              value={horaFinal}
              onChange={(e) => setHoraFinal(e.target.value)}
            />
          </div>

          <div className="col-md-2">
            <label htmlFor="aula" className="form-label">Aula</label>
            <input
              type="text"
              className="form-control"
              id="aula"
              value={aula}
              onChange={(e) => setAula(e.target.value)}
            />
          </div>
          {/* Botones */}
          <div className="d-flex justify-content-center gap-3 mt-4">
            <button className="btn btn-success px-4">Registrar</button>
            {/*  Salir al inicio del rol actual (sin cerrar sesión) */}
            <button type="button" className="btn btn-danger px-4" onClick={handleSalir}>
             Salir
            </button>
          </div>
        </form>
      </div>

      {/* === NUEVO: Tabla de horarios con disponibilidad por día === */}
      <table className="table table-bordered table-striped mt-4 text-center">
        <thead className="table-dark">
          <tr>
            <th>Hora</th>
            {dias.map((d) => (
              <th key={d}>{d}</th>
            ))}
          </tr>
        </thead>
        <tbody id="tablaBody">
          {bloques.map((rango) => {
            const [iniBloque, finBloque] = rango.split(' - ');
            return (
              <tr key={rango}>
                <td>{rango}</td>
                {dias.map((d) => {
                  const aplicar =
                    diaSemana && horaInicioNorm && horaFinalNorm && d === diaSemana;

                  if (aplicar && traslapan(horaInicioNorm, horaFinalNorm, iniBloque, finBloque)) {
                    return (
                      <td key={`${rango}-${d}`} className="no-disponible table-danger">
                        No disponible
                      </td>
                    );
                  }
                  return (
                    <td key={`${rango}-${d}`} className="disponible">
                      Disponible
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

/* ----------------- Helper para detectar el rol ----------------- */
function resolveRolBase(pathname) {
  // 1) Intenta desde la URL actual
  const roles = ['directora', 'coordinadora', 'docente', 'alumno'];
  const seg = pathname.split('/').filter(Boolean)[0];
  if (roles.includes(seg)) return seg;

  // 2) Respaldo desde localStorage.role (números mapeados a slugs)
  const roleId = Number(localStorage.getItem('role'));
  const map = { 1: 'directora', 2: 'coordinadora', 3: 'docente', 4: 'alumno' };
  return map[roleId] || null;
}


export default RegistrarHorarios;
